import ImageService from '@/services/ImageService'  
import GLTFService from '@/services/GLTFService' 
 
import AppStore from 'src/store/app'
import { HOME, PATHS } from '@/config/app'
import Env from 'src/config/env'
import AnimationConfig from 'src/config/animation'

import { clamp, map, DEG_TO_RAD } from '@/helpers/MathUtils'
import Pointer from '@/helpers/Pointer'
import EventEmitter from 'src/helpers/EventEmitter'
  
import BaseGroup from '@/components/stage/common/base_group'
 
import gsap from 'gsap'
import dat from 'dat.gui' 

const THREE = require('three')
import { SkeletonUtils } from 'three/examples/jsm/utils/SkeletonUtils.js'

// displacement
import vert_morph from '@/shaders/displacement/vertex_morph.glsl'
import vert_before_morph from '@/shaders/displacement/vertex_before_morph.glsl'


const Events = {}
 

class Character extends BaseGroup {

  constructor(config) { 

    super(config) 

    this.Events = Events
    Object.assign(this, EventEmitter)

    this.setup()
    this.resize()
 
    this.frustumCulled = false
  }

  setup() { 

    this.frame = 0
    this.mixers = [] 
    this.options = {

      manScale: 0.65,
      manPosY: -1.5,
      manPosZ: -.3,
   
      skeleton: {
        playbackspeed: 0.5,
        playing: true
      }, 
      materials: {
        outside: {
          visible: true,
          color: 0xff3232,
          textureAmt: 0.01,
          textureScale: 150.,
          matCapAmt: 0.5
        },
        inside: {
          visible: true,
          color: 0xFFFFFF
        },
        outsideback: {
          visible: true,
          color: 0xff002d
        }
      }
    }
  }

  traverseMeshWithMaterials (object, callback) {
    object.traverse((node) => {
      if (node.isMesh && node.material) {
        callback(node)
      }
    })
  }
 
  setupMaterials(){
 
    const gltf = GLTFService.get( require('@/assets/models/boy4.glb') )
    const man_mesh = gltf.scenes[0]
    const clips = gltf.animations || [];
    man_mesh.scale.set( 0.01,  0.01,  0.01)
    man_mesh.position.y = -1.5


    // character materials - - - - - - - - - - 
 
    const tOutsideFront = new THREE.Texture( ImageService.get( require('@/assets/imgs/inside.jpg') ) )
    tOutsideFront.needsUpdate = true

    this.materialOutsideFront = new THREE.MeshMatcapMaterial({  
      skinning:true,
      transparent: true,
      opacity: 0 ,
      depthTest: true,
      depthWrite: true,
     //  depthFunc: THREE.LessEqualDepth ,
      matcap: tOutsideFront,
      color: new THREE.Color(this.options.materials.outside.color)
    })

    // var textureLoader = new THREE.TextureLoader()
    // var outsideTexture = require('@/assets/imgs/checkbox.jpg')
    // var texture1 = textureLoader.load(outsideTexture)
    // texture1.wrapS = THREE.RepeatWrapping
    // texture1.wrapT = THREE.RepeatWrapping 
    // texture1.needsUpdate = true
    // var size = new THREE.Vector3()
    // var box = new THREE.Box3().setFromObject(man_mesh) 
    // box.getSize(size)


    this.materialOutsideFront.userData.textureAmt = { value: this.options.materials.outside.textureAmt } 
    this.materialOutsideFront.userData.textureScale = { value: this.options.materials.outside.textureScale } 
    this.materialOutsideFront.userData.matCapAmt = { value: this.options.materials.outside.matCapAmt } 
    this.materialOutsideFront.userData.colorMix = { value: 1. } 
 
    this.materialOutsideFront.onBeforeCompile = shader => {  

      // shader.uniforms.size = { value: size};
      // shader.uniforms.tex1 = { value: texture1};  

      shader.uniforms.textureAmt = this.materialOutsideFront.userData.textureAmt
      shader.uniforms.textureScale = this.materialOutsideFront.userData.textureScale
      shader.uniforms.matCapAmt = this.materialOutsideFront.userData.matCapAmt
      shader.uniforms.colorMix = this.materialOutsideFront.userData.colorMix

      // shader.vertexShader = 'varying vec4 vWorldPosition;\nvarying vec2 vUv;\n' + shader.vertexShader;
      // shader.vertexShader = shader.vertexShader.replace(
      //   '#include <worldpos_vertex>',
      //   [
      //     '#include <worldpos_vertex>',
      //     'vUv = uv;'
      //     //'vWorldPosition = modelMatrix * vec4( transformed, 1.0 );'
      //   ].join( '\n' )
      // ); 


      shader.fragmentShader = [ 
          // 'uniform sampler2D tex1;', 
          // 'uniform vec3 size;', 
          'uniform float textureAmt;',
          'uniform float textureScale;',
          'uniform float matCapAmt;', 
          'uniform float colorMix;', 
          //'varying vec2 vUv;',
          '',
        ].join( '\n' ) + shader.fragmentShader;
    
      shader.fragmentShader = shader.fragmentShader.replace( '#include <diffuse_fragment>', '' ); 
      shader.fragmentShader = shader.fragmentShader.replace(
        '#include <fog_fragment>',
        [ 
          '#include <fog_fragment>',  
          'vec4 matCap = gl_FragColor;',  
          //'vec4 texColorA = texture2D(tex1, gl_FragCoord.xy / textureScale );',  
          'vec4 color = vec4(mix(diffuse.rgb * 0.5, diffuse.rgb * 1.2, colorMix ), 1.);',  
          //'vec4 texColorB = mix( color, color * texColorA, textureAmt);',  
          'gl_FragColor = mix(color, matCap * color, 0.5);',
        ].join( '\n' )
      )

    }

    this.materialInside = new THREE.MeshMatcapMaterial({ 
      skinning:true,
      transparent: true,
      opacity: 0,
      depthTest: true,
      depthWrite: true,
      // stencilFunc: THREE.LessStencilFunc,
      matcap: this.textures.blue_matcap,
      color: new THREE.Color(this.options.materials.inside.color)
    }) 
 

    this.meshInside = SkeletonUtils.clone( man_mesh );
    this.meshInside.frustumCulled = false
    this.traverseMeshWithMaterials(this.meshInside, mesh => {mesh.material = this.materialInside }) 

    this.meshOuter = SkeletonUtils.clone( man_mesh );
    this.meshOuter.frustumCulled = false
    this.traverseMeshWithMaterials(this.meshOuter, mesh => { mesh.material = this.materialOutsideFront })

      
    this.mixers = [
      new THREE.AnimationMixer( this.meshInside ), 
      new THREE.AnimationMixer( this.meshOuter )
    ]

    this.man_meshs = [
      this.meshInside, 
      this.meshOuter
    ]
 

    this.clips = {}
    this.clips['fillOne'] = clips[ 0 ]
    this.clips['fillTwo'] = clips[ 1 ]
    this.clips['rotate'] = clips[ 2 ]
    this.clips['ambient'] = clips[ 3 ] 
    
    this.actions = [] 
    for (var i = 0; i < this.mixers.length; i++) { 

      const mixer = this.mixers[ i ]
      let actions = {}
      actions['fillOne'] = mixer.clipAction( this.clips.fillOne )
      actions['fillTwo'] = mixer.clipAction( this.clips.fillTwo )
      actions['rotate'] = mixer.clipAction( this.clips.rotate )
      actions['ambient'] = mixer.clipAction( this.clips.ambient )
      actions.rotate.loop = THREE.LoopOnce 
      actions.fillOne.loop = THREE.LoopOnce 
      
      this.actions.push(actions)
    } 

    this.updatePlayback()


    for (var j = 0; j < this.man_meshs.length; j++) { 
      this.man_meshs[j].position.x = 10  
    }
  }


  executeCrossFade( startAction, endAction, duration = 2, weight = 1, timeScale = 1, warp = true ) {

    // Not only the start action, but also the end action must get a weight of 1 before fading
    // (concerning the start action this is already guaranteed in this place)
    this.setWeight( endAction, weight, timeScale )
    endAction.time = 0

    // Crossfade with warping - you can also try without warping by setting the third parameter to false
    startAction.crossFadeTo( endAction, duration, warp ) 
  }
 
  setWeight( action, weight, timeScale ) {
    action.enabled = true
    action.setEffectiveTimeScale( timeScale )
    action.setEffectiveWeight( weight ) 
  }
 
  onCharacterChange(){ 
        
    if(this.man_meshs){ 

      // transform
      for (var i = 0; i < this.man_meshs.length; i++) {
        this.man_meshs[i].scale.x = this.man_meshs[i].scale.y = this.man_meshs[i].scale.z = this.options.manScale//0.65
        this.man_meshs[i].position.y = this.options.manPosY //-2
        this.man_meshs[i].position.z = this.options.manPosZ // -.5
      }

      // Materials 
      this.meshInside.visible = this.options.materials.inside.visible
      this.meshOuter.visible = this.options.materials.outside.visible
      // this.meshOuterBack.visible = this.options.materials.outsideback.visible

      this.materialOutsideFront.userData.textureAmt.value = this.options.materials.outside.textureAmt
      this.materialOutsideFront.userData.textureScale.value = this.options.materials.outside.textureScale  
      this.materialOutsideFront.userData.matCapAmt.value = this.options.materials.outside.matCapAmt 

    } 
  }

  updatePlayback(force_stop=false){
 
    for (var i = 0; i < this.mixers.length; i++) {
      // this.man_clips.forEach(clip => { 

      //   let action = this.mixers[i].clipAction(clip) 
      //   if(action){

      //     // play / stop
      //     if(force_stop || this.reduced_motion){
      //       action.stop()
      //     } else {
      //       action.play()
      //     } 

      //     // playback speed
      //     action.setEffectiveTimeScale( this.options.skeleton.playbackspeed ) 
      //   }
      // })


      let mixer = this.mixers[i] 
      let action = mixer.clipAction( this.clips.ambient  ) 
      if(action){

        // play / stop
        if(force_stop || this.reduced_motion){
          action.stop()
        } else {
          action.play()
        } 

        // playback speed
        action.setEffectiveTimeScale( this.options.skeleton.playbackspeed ) 
      }
    }

  }
 
  // addGUI() {

  //   this.characterFolder = this.gui.addFolder('Character')

  //   this.skeletonFolder = this.characterFolder.addFolder('Skeleton')
  //   this.skeletonFolder.add(this.options.skeleton, 'playbackspeed', 0, 2).onChange(this.onCharacterChange)
  //   this.skeletonFolder.add(this.options.skeleton, 'playing').onChange(this.onCharacterChange)

  //   this.transformFolder = this.characterFolder.addFolder('Transform')
  //   this.transformFolder.add(this.options, 'manScale', 0, 2).onChange(this.onCharacterChange)
  //   this.transformFolder.add(this.options, 'manPosZ', -5, 5).onChange(this.onCharacterChange)
  //   this.transformFolder.add(this.options, 'manPosY', -5, 5).onChange(this.onCharacterChange)


  //   // character materials
  //   this.characterMatFolder = this.characterFolder.addFolder('Materials')

  //   // inside
  //   this.characterInsideMatFolder = this.characterMatFolder.addFolder('Inside')
  //   this.characterInsideMatFolder.addColor(this.options.materials.inside, 'color' ).onChange( () => {
  //     this.materialInside.color = new THREE.Color(this.options.materials.inside.color)
  //   })
  //   this.characterInsideMatFolder.add(this.options.materials.inside, 'visible').onChange(this.onCharacterChange)

  //   // outside
  //   this.characterOutsideMatFolder = this.characterMatFolder.addFolder('Outside')
  //   this.characterOutsideMatFolder.addColor(this.options.materials.outside, 'color' ).onChange( () => {  
  //     this.materialOutsideFront.color = new THREE.Color(this.options.materials.outside.color)
  //   })
  //   this.characterOutsideMatFolder.add(this.options.materials.outside, 'textureAmt', 0, 1).step(0.1).onChange(this.onCharacterChange)
  //   this.characterOutsideMatFolder.add(this.options.materials.outside, 'textureScale', 150, 1000).step(0.01).onChange(this.onCharacterChange)
  //   this.characterOutsideMatFolder.add(this.options.materials.outside, 'matCapAmt', 0, 1).step(0.1).onChange(this.onCharacterChange)
  //   this.characterOutsideMatFolder.add(this.options.materials.outside, 'visible').onChange(this.onCharacterChange)
  // }

  updateGUI () {}
  
  pointerMove(event){ }

  pointerStart(event){ }

  pointerEnd(event){ }
 
  setReducedMotion(val){ 
    this.reduced_motion = val
    this.views.forEach( view => view.setReducedMotion( this.reduced_motion ) )
    this.updatePlayback()  
  }


  // UPDATES -------------------------------------------------------------------
  
  tick( dt, time, opacity ) {  
    for (var i = 0; i < this.mixers.length; i++) {
      this.mixers[i].update(dt)
    }
    if(this.materialOutsideFront){
      this.frame += 0.01
      this.materialOutsideFront.userData.colorMix.value = opacity 
    }
  }

  resize(){}

  destroy(){}

  characterLoaded(){
    this.setupMaterials()
    //this.addGUI()
  }  

  enter(){ }

  leave(){ }



  // HANDLERS -------------------------------------------------------------------



  // STATES -------------------------------------------------------------------

  /* modal states */

  /*  
    none
    menu
    video
  */

  /* page states */

  routeLoading(){} 
 
  routeHome(){}
  

  /* home states */
 
  welcome(val, prev){ 

    let clamp = this.reduced_motion ? 0 : 1
    let duration = 1.2 * clamp  
    gsap.to([this.materialInside, this.materialOutsideFront], duration, {
      opacity: 0, 
      ease: 'expo.inOut'
    }) 
   // this.updatePlayback(true)

  } 
 
  ratingFive(val, prev){

    let clamp = this.reduced_motion ? 0 : 1
    let duration = 1 * clamp  
    gsap.to([this.materialInside, this.materialOutsideFront], duration, {opacity: 1, delay: 0.5 * clamp ,  ease: 'expo.inOut' })

    for (var j = 0; j < this.man_meshs.length; j++) { 
      this.man_meshs[j].position.x = 0 
      this.man_meshs[j].scale.set( 0.65,  0.65,  0.65)
    }
  } 

  ratingFour(val, prev){
    
    const home = AppStore.state.home 
    const isHomeModeDefault = ( home.mode === HOME.MODES.DEFAULT ) 
    const base_delay = ( AnimationConfig.home.section.duration * 0.75 )
    const delay = isHomeModeDefault ? base_delay : 0

    if(isHomeModeDefault){ 
      for (var i = 0; i < this.actions.length; i++) { 
        this.actions[i].fillTwo.reset().play() 
        this.executeCrossFade(this.actions[i].ambient, this.actions[i].fillTwo, delay * 0.2, 0.5, 0.3, false )
      } 
      gsap.delayedCall(delay * 0.75, () => {
         for (var i = 0; i < this.actions.length; i++) {  
          this.executeCrossFade(this.actions[i].fillTwo, this.actions[i].ambient, delay * 0.25, 1, 1, false )
        } 
      }) 
    }

    gsap.delayedCall(delay, () => {
      for (var i = 0; i < this.actions.length; i++) { 
        this.actions[i].fillOne.reset().play() 
        this.executeCrossFade(this.actions[i].ambient, this.actions[i].fillOne, 0.5, 0.2, 1, false )
      } 
      gsap.delayedCall(1, () => {
         for (var i = 0; i < this.actions.length; i++) {  
          this.executeCrossFade(this.actions[i].fillOne, this.actions[i].ambient, 0.5, 1, 0.5, false )
        } 
      })
    })
  } 
 
  ratingThree(val, prev){ 
   
    const home = AppStore.state.home 
    const isHomeModeDefault = ( home.mode === HOME.MODES.DEFAULT ) 
    const base_delay = ( AnimationConfig.home.section.duration * 0.75 )
    const delay = isHomeModeDefault ? base_delay : 0 

    if(isHomeModeDefault){ 
      for (var i = 0; i < this.actions.length; i++) { 
        this.actions[i].fillTwo.reset().play() 
        this.executeCrossFade(this.actions[i].ambient, this.actions[i].fillTwo, delay * 0.25, 0.7, 0.25, false )
      } 
      gsap.delayedCall(delay * 0.75, () => {
         for (var i = 0; i < this.actions.length; i++) {  
          this.executeCrossFade(this.actions[i].fillTwo, this.actions[i].ambient, delay * 0.25, 1, 1, false )
        } 
      }) 
    }

    gsap.delayedCall( delay, () => {
      for (var i = 0; i < this.actions.length; i++) { 
        this.actions[i].fillTwo.reset().play() 
        this.executeCrossFade(this.actions[i].ambient, this.actions[i].fillTwo, 0.5, 0.3, 1, false )
      } 
      gsap.delayedCall(1, () => {
         for (var i = 0; i < this.actions.length; i++) {  
          this.executeCrossFade(this.actions[i].fillTwo, this.actions[i].ambient, 0.5, 1, 0.5, false )
        } 
      })
    })
  }

  ratingTwo(val, prev){

    const home = AppStore.state.home 
    const isHomeModeDefault = ( home.mode === HOME.MODES.DEFAULT ) 
    const base_delay = ( AnimationConfig.home.section.duration * 0.75 )
    const delay = isHomeModeDefault ? base_delay : 0 

    if(isHomeModeDefault){ 
      for (var i = 0; i < this.actions.length; i++) { 
        this.actions[i].fillTwo.reset().play() 
        this.executeCrossFade(this.actions[i].ambient, this.actions[i].fillTwo, delay * 0.25, 0.8, 0.3, false )
      } 
      gsap.delayedCall(delay * 0.75, () => {
         for (var i = 0; i < this.actions.length; i++) {  
          this.executeCrossFade(this.actions[i].fillTwo, this.actions[i].ambient, delay * 0.25, 1, 1, false )
        } 
      })   
    }
  
    gsap.delayedCall( delay, () => {
      for (var i = 0; i < this.actions.length; i++) { 
        this.actions[i].fillOne.reset().play() 
        this.executeCrossFade(this.actions[i].ambient, this.actions[i].fillOne, 0.25, 0.5, 1, false )
      } 
      gsap.delayedCall(1, () => {
         for (var i = 0; i < this.actions.length; i++) {  
          this.executeCrossFade(this.actions[i].fillOne, this.actions[i].ambient, 1.5, 1, 0.75, false )
        } 
      })
    })
  } 
 
  ratingOne(val, prev){

    const home = AppStore.state.home 
    const isHomeModeDefault = ( home.mode === HOME.MODES.DEFAULT ) 
    const base_delay = ( AnimationConfig.home.section.duration * 0.75 )
    const delay = isHomeModeDefault ? base_delay : 0 

    if(isHomeModeDefault){ 
      for (var i = 0; i < this.actions.length; i++) { 
        this.actions[i].fillTwo.reset().play() 
        this.executeCrossFade(this.actions[i].ambient, this.actions[i].fillTwo, delay * 0.25, 1, 0.3, false )
      } 
      gsap.delayedCall(delay * 0.75, () => {
         for (var i = 0; i < this.actions.length; i++) {  
          this.executeCrossFade(this.actions[i].fillTwo, this.actions[i].ambient, delay * 0.25, 1, 1, false )
        } 
      }) 
    }


    gsap.delayedCall( delay, () => {
      for (var i = 0; i < this.actions.length; i++) { 
        this.actions[i].fillOne.reset().play() 
        this.executeCrossFade(this.actions[i].ambient, this.actions[i].fillOne, 0.25, 1, 1, false )
      } 
      gsap.delayedCall(1, () => {
         for (var i = 0; i < this.actions.length; i++) {  
          this.executeCrossFade(this.actions[i].fillOne, this.actions[i].ambient, 1.5, 1, 0.75, false )
        } 
      })
    })
  } 

  cta(val, prev){
     
    const base_delay = ( AnimationConfig.home.section.duration * 0.75 )
    for (var i = 0; i < this.actions.length; i++) { 
      this.actions[i].fillTwo.reset().play() 
      this.executeCrossFade(this.actions[i].ambient, this.actions[i].fillTwo, base_delay * 0.25, 1, 0.3, false )
    } 
    gsap.delayedCall(base_delay * 0.75, () => {
       for (var i = 0; i < this.actions.length; i++) {  
        this.executeCrossFade(this.actions[i].fillTwo, this.actions[i].ambient, base_delay * 0.25, 1, 1, false )
      } 
    }) 
  } 

}
 

export default Character